import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_spread_props } from "@swc/helpers/_/_object_spread_props";
export function setVendorLogo(relationship, logoUrl) {
    return _object_spread_props(_object_spread({}, relationship), {
        vendor: _object_spread_props(_object_spread({}, relationship.vendor), {
            logoUrl
        })
    });
}
